import { FormEt004 } from './../../entity/forms/form-et004';
import { FormularioService } from './../../services/formulario.service';
import { NotificationService } from './../../services/notification.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit, ViewChild, AfterViewInit, SimpleChanges, OnChanges, enableProdMode } from '@angular/core';
import { CabecalhoDTO } from 'src/app/entity/dto/cabecalho.component';
import { GeneralService } from 'src/app/services/general.service';
import { ActivatedRoute } from '@angular/router';
import { EnumFormType } from 'src/app/entity/enum/enum-form-type';
import { BehaviorSubject } from 'rxjs';
import { EnumForm } from 'src/app/entity/enum/enum-form';
import { Et004CardIComponent } from './partialViews/et004-card-I.component';
import { Et004CardIIComponent } from './partialViews/et004-card-II.component';
import { Et004CardIIIComponent } from './partialViews/et004-card-III.component';
import { Et004CardIVComponent } from './partialViews/et004-card-IV.component';
import { Et004CardVComponent } from './partialViews/et004-card-V.component';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { FindValueSubscriber } from 'rxjs/internal/operators/find';
import { FormModalConfirmComponent } from 'src/app/shared/form-modal-confirm/form-modal-confirm.component';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { ResumeAllFormsService } from 'src/app/services/resume-all-forms.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-form-et004',
  templateUrl: './form-et004.component.html'
})

export class FormEt004Component implements OnInit, AfterViewInit {


  public header?: CabecalhoDTO;
  public formulario?: FormGroup;
  public btnCollapse?: boolean;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public enableButtons = this.loadingSubject.asObservable();
  public showButtonSync = false;
  public formEt004: FormEt004 = new FormEt004();
  public valueConfirm: number;
  valuesInitial: any;
  valoresAlterados: any[] = [];
  currentUser: string = "";

  @ViewChild(Et004CardIComponent, { static: false }) et004CardIComponent: Et004CardIComponent;
  @ViewChild(Et004CardIIComponent, { static: false }) et004CardIIComponent: Et004CardIIComponent;
  @ViewChild(Et004CardIIIComponent, { static: false }) et004CardIIIComponent: Et004CardIIIComponent;
  @ViewChild(Et004CardIVComponent, { static: false }) et004CardIVComponent: Et004CardIVComponent;
  @ViewChild(Et004CardVComponent, { static: false }) et004CardVComponent: Et004CardVComponent;
  @ViewChild(FormModalConfirmComponent, { static: false }) formModalConfirm: FormModalConfirmComponent;
  notificationPesoBO: boolean = false

  // tslint:disable-next-line: max-line-length
  constructor(protected formBuilder: FormBuilder, protected generalService: GeneralService, protected notificationService: NotificationService, protected formularioService: FormularioService, protected route: ActivatedRoute, protected resumeAllFormsService: ResumeAllFormsService, public dialog: MatDialog) {
    this.formulario = this.formEt004.CreateForm(formBuilder);
  }
  async ngAfterViewInit(): Promise<void> {
    this.route.data.subscribe(async (data: any) => {
      if (!!data) {
        this.valuesInitial = data?.formulario ?? this.formulario.getRawValue();;
        const type = (this.route?.snapshot?.params?.type);
        const isReadOnly: boolean = type === '2' ? true : false;
        this.loadingSubject.next(isReadOnly ? false : true);
        if (type === '1' || type === '2') {
          if (type === '1') {
            this.header = this.generalService.createHeader(EnumForm.FormEt004, EnumFormType.Edit);
          } else {
            this.header = this.generalService.createHeader(EnumForm.FormEt004, EnumFormType.Details);
          }

          if (data.formulario.offline) {
            this.showButtonSync = true;
          }
          await this.updateForm(data);
        } else {
          await this.getUser();
          this.fillCreatedByFormField();
          this.header = this.generalService.createHeader(EnumForm.FormEt004, EnumFormType.New);
          this.et004CardIComponent.formulario.get('site').setValue(this.generalService.getLocalStorageDataSite());
          this.verifySiteLote()
        }
      }
    });
  }
  verifySiteLote() {
    const site = this.et004CardIComponent.formulario.get('site').value as string;
    if (site.toUpperCase() == 'ITA') {
      this.et004CardIComponent.isShowLotePosLimpeza = true
    }
    else {
      this.et004CardIComponent.isShowLotePosLimpeza = false
    }
  }

  async ngOnInit(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    this.header = this.generalService.createHeader(EnumForm.FormEt004, EnumFormType.New);
    this.btnCollapse = true;
    this.loadingSubject.next(false);

  }

  private async getUser(): Promise<void> {
    await this.formularioService.getUser().pipe(take(1)).toPromise().then(response => {
      this.currentUser = response['user-profile']?.displayName ?? 'Administrador';
    }).catch(async error => {
      await this.generalService.getUserNameValue().pipe(take(1)).toPromise().then((response: string) => {
        this.currentUser = response;
      }).catch(err => {
      });
    });
  }

  private fillCreatedByFormField(): void {
    this.et004CardVComponent.formulario.get('criado_por').setValue(this.currentUser);
  }

  async makeCalculations(event?: any): Promise<void> {
    await this.checkLotePosLimpeza();
    await this.getConsumoPoncho();
    await this.getConsumoCruiser();
    await this.getConsumoRedigo();
    await this.getConsumoDermacor();
    await this.veirifyPonchoOrCruiser();
    await this.ValidateTratamentoDate();
    await this.ValidateHour();
    await this.calcIngredienteAtivoLaudo();

  }



  async makeCalculationsII(event?: any): Promise<void> {
    await this.getNumSemente();
    await this.getPesoLiquidoRegCBT200();
    await this.getPesoMilSementes();
    await this.getPoncho();
    await this.getCruiser();
    await this.getRedigo();
    await this.getDermacor();
    await this.getTalkumGloss();
    await this.veirifyPonchoOrCruiser();
    await Promise.all([this.checkPolimeroField(), this.checkAguaField(), this.checkCaldaConvencionalField(), this.calcIngredienteCorrecao()]);
  }
  async makeCalculationsIII($event: Event) {
    await this.getCalcCaldaTsi();
  }

  async save(): Promise<void> {

    const id: number = this.formulario.get('id').value as number;
    const isAddFlow = id === 0;
    if (await this.validFormsToSave() === '') {
      await this.buildFormulario();
      //await this.formularioService.saveForm(id, this.formulario.getRawValue(), 'et004', 'formet004');
      await this.resumeAllFormsService.compareAdd(this.valuesInitial, this.formulario.getRawValue(), isAddFlow, 'et004');
      this.openConfirmDialog(this.resumeAllFormsService.valoresAlterados, isAddFlow);
    }
  }

  public async openConfirmDialog(valoresAlterados: any[], isAddFlow): Promise<void> {
    const values: any[] = valoresAlterados;
    const dialogRef = this.dialog.open(FormModalConfirmComponent, {
      data: {
        valoresAlterados: values,
        isAddFlow
      }
    });
    dialogRef.afterClosed().subscribe(x => {
      if (x.save) {
        const id: number = this.formulario.get('id').value as number;
        this.formularioService.saveForm(id, this.formulario.getRawValue(), 'et004', 'formet004');
      }
      else {
        this.resumeAllFormsService.valoresAlterados = [];
      }
    })
  }

  async saveConfirm($event: any) {
    const id: number = this.formulario.get('id').value as number;
    await this.formularioService.saveForm(id, this.formulario.getRawValue(), 'et004', 'formet004');

  }

  async getForms(): Promise<FormGroup[]> {
    const arrForms: Array<FormGroup> = new Array<FormGroup>();
    arrForms.push(this.et004CardIComponent.formulario);
    arrForms.push(this.et004CardIIComponent.formulario);
    arrForms.push(this.et004CardIIIComponent.formulario);
    arrForms.push(this.et004CardIVComponent.formulario);
    arrForms.push(this.et004CardVComponent.formulario);
    return await arrForms;
  }

  async validFormsToSave(): Promise<string> {
    return await this.formularioService.validForm(await this.getForms());
  }

  async cleanAll(): Promise<void> {
    await this.formularioService.cleanForm(await this.getForms());
    this.et004CardIComponent.formulario.get('site').setValue(this.generalService.getLocalStorageDataSite());
    this.verifySiteLote()
  }

  async collapseAll(): Promise<void> {
    this.btnCollapse = this.btnCollapse ? false : true;
    this.et004CardIComponent.collapseCard = this.btnCollapse ? false : true;
    this.et004CardIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.et004CardIIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.et004CardIVComponent.collapseCard = this.btnCollapse ? false : true;
    this.et004CardVComponent.collapseCard = this.btnCollapse ? false : true;
  }

  public async buildFormulario(): Promise<void> {
    this.formulario = await this.formEt004.buildForm(this.formulario, await this.getForms(), this.generalService);
  }

  private async updateForm(data?: any): Promise<void> {
    this.formulario.get('id').setValue(data.formulario.id);
    if (data.formulario.hasOwnProperty('offline')) {
      this.formulario.get('offline').setValue(true);
    }
    await this.formEt004.updateForm(data, await this.getForms(), this.generalService);
    await Promise.all([this.checkPolimeroField(), this.checkAguaField(), this.checkCaldaConvencionalField(), this.veirifyPonchoOrCruiser(data.formulario)]);
    this.checkSafra();
    this.verifySiteLote();
  }

  private checkSafra() {

    const safra = this.et004CardIComponent.formulario.get('safra').value as any;

    if (safra.length > 0) {
      this.et004CardIComponent.formulario.get('safra').disable();
    }
  }

  // INICIO DO CODIGO DE CALCULO

  private async getNumSemente(): Promise<void> {
    let resultado: number = 0;
    const num: number = 1000;
    const mult: number = 10000;
    const pesoDezMilSem = !!this.et004CardIComponent.formulario.get('peso_dez_mil_sementes').value ? this.et004CardIComponent.formulario.get('peso_dez_mil_sementes')?.value as number ?? 0 : 0;
    if (pesoDezMilSem > 0) {
      resultado = (num * mult) / pesoDezMilSem;
    }
    this.et004CardIComponent.formulario.get('num_sementes').setValue(resultado);
  }

  private async getPesoLiquidoRegCBT200(): Promise<void> {
    let resultado: number = 0;
    const num: number = 60000;
    const numSemente = !!this.et004CardIComponent.formulario.get('num_sementes').value ? this.et004CardIComponent.formulario.get('num_sementes')?.value as number ?? 0 : 0;
    if (numSemente > 0) {
      resultado = num / numSemente;
    }
    this.et004CardIComponent.formulario.get('peso_liquido_regulagem_cbt').setValue(resultado);
  }

  private async getPesoMilSementes(): Promise<void> {
    let resultado: number = 0;
    const num: number = 60;
    const pesoLiquidoRegCbt = !!this.et004CardIComponent.formulario.get('peso_liquido_regulagem_cbt').value ? this.et004CardIComponent.formulario.get('peso_liquido_regulagem_cbt')?.value as number ?? 0 : 0;
    resultado = pesoLiquidoRegCbt / 60;
    this.et004CardIComponent.formulario.get('peso_mil_sementes').setValue(resultado);
  }

  private async veirifyPonchoOrCruiser(data = null): Promise<void> {
    const arrCampos = [
      'pump_station_',
      'pump_station_calda_',
      'ingrediente_ativo_laudo_produto_',
      'correcao_aplicacao_',
      'consumo_',
      'correcao_ia_',
      'correcao_perda_processo_',
      ''
    ]
    const arrSunflix = [
      'poncho',
      'cruiser',
      'redigo',
      'dermacor',
      'convencional'
    ]
    const tipoTratamento: string = (this.et004CardIComponent.formulario.get('tipo_tratamento')?.value as string ?? '').toUpperCase()

    const pumpStationCruiserInput = this.et004CardIIComponent.formulario.get('pump_station_cruiser');

    const correcaoAplicacaoCruiser = this.et004CardIIComponent.formulario.get('correcao_aplicacao_cruiser');

    const dosagenCruiser = this.et004CardIIIComponent.formulario.get('cruiser');

    const consumoCruiser = this.et004CardVComponent.formulario.get('consumo_cruiser')

    const verificaTipoTratamentoPoncho = tipoTratamento.includes('PONCHO')
    const verificaTipoTratamentoCruiser = tipoTratamento.includes('CRUISER')
    const verificaTipoTratamentoConvencional = tipoTratamento.includes('CONVENCIONAL')
    const verificaTipoTratamentoDermacor = tipoTratamento.includes('DERMACOR')
    const verificaTipoTratamentoRedigo = tipoTratamento.includes('REDIGO')


    this.et004CardIIComponent.isReadOnlyDermacor = false;
    this.et004CardIIComponent.isReadOnlyCruiser = false;
    this.et004CardIIComponent.isReadOnlyRedigo = false;
    this.et004CardIIComponent.isReadOnlyPoncho = false;
    this.et004CardIIComponent.isReadOnlyTSI = false;

    if (verificaTipoTratamentoPoncho && !verificaTipoTratamentoRedigo && !verificaTipoTratamentoDermacor) {

      this.et004CardIIComponent.isReadOnlyDermacor = true;
      this.et004CardIIComponent.isReadOnlyCruiser = true;
      this.et004CardIIComponent.isReadOnlyRedigo = true;

      arrCampos.forEach(item => {
        arrSunflix.forEach(flix => {
          if (flix != 'poncho') {
            this.getFormCard(item + flix).get(item + flix)?.disable();
            this.getFormCard(item + flix)?.get(item + flix)?.setValue(null);
          }
          else {
            this.getFormCard(item + flix)?.get(item + flix)?.enable();
          }
        })
      })
      return
    }

    if (verificaTipoTratamentoPoncho && verificaTipoTratamentoRedigo && !verificaTipoTratamentoDermacor) {

      this.et004CardIIComponent.isReadOnlyDermacor = true;
      this.et004CardIIComponent.isReadOnlyCruiser = true;

      arrCampos.forEach(item => {
        arrSunflix.forEach(flix => {
          if (flix != 'poncho' && flix != 'redigo') {
            this.getFormCard(item + flix).get(item + flix)?.disable();
            this.getFormCard(item + flix).get(item + flix)?.setValue(null);
          }
          else {
            this.getFormCard(item + flix).get(item + flix)?.enable();
          }
        })
      })
      return
    }

    if (verificaTipoTratamentoPoncho && verificaTipoTratamentoRedigo && verificaTipoTratamentoDermacor) {

      this.et004CardIIComponent.isReadOnlyCruiser = true;

      arrCampos.forEach(item => {
        arrSunflix.forEach(flix => {
          if (flix != 'poncho' && flix != 'redigo' && flix != 'dermacor') {
            this.getFormCard(item + flix).get(item + flix)?.disable();
            this.getFormCard(item + flix).get(item + flix)?.setValue(null);
          }
          else {
            this.getFormCard(item + flix).get(item + flix)?.enable();
          }
        })
      })
      return
    }

    if (verificaTipoTratamentoCruiser && verificaTipoTratamentoDermacor && verificaTipoTratamentoRedigo) {

      this.et004CardIIComponent.isReadOnlyPoncho = true;

      arrCampos.forEach(item => {
        arrSunflix.forEach(flix => {
          if (flix != 'cruiser' && flix != 'dermacor' && flix != 'redigo') {
            this.getFormCard(item + flix).get(item + flix)?.disable();
            this.getFormCard(item + flix).get(item + flix)?.setValue(null);
          }
          else {
            this.getFormCard(item + flix).get(item + flix)?.enable();
          }
        })
      })
      return
    }

    if (verificaTipoTratamentoCruiser && verificaTipoTratamentoDermacor) {

      this.et004CardIIComponent.isReadOnlyRedigo = true;
      this.et004CardIIComponent.isReadOnlyPoncho = true;

      arrCampos.forEach(item => {
        arrSunflix.forEach(flix => {
          if (flix != 'cruiser' && flix != 'dermacor') {
            this.getFormCard(item + flix).get(item + flix)?.disable();
            this.getFormCard(item + flix).get(item + flix)?.setValue(null);
          }
          else {
            this.getFormCard(item + flix).get(item + flix)?.enable();
          }
        })
      })
      return
    }

    if (verificaTipoTratamentoPoncho && !verificaTipoTratamentoRedigo && verificaTipoTratamentoDermacor) {

      this.et004CardIIComponent.isReadOnlyCruiser = true;
      this.et004CardIIComponent.isReadOnlyRedigo = true;

      arrCampos.forEach(item => {
        arrSunflix.forEach(flix => {
          if (flix != 'poncho' && flix != 'dermacor') {
            this.getFormCard(item + flix).get(item + flix)?.disable();
            this.getFormCard(item + flix).get(item + flix)?.setValue(null);
          }
          else {
            this.getFormCard(item + flix).get(item + flix)?.enable();
          }
        })
      })
      return
    }

    if (verificaTipoTratamentoDermacor) {

      this.et004CardIIComponent.isReadOnlyPoncho = true;
      this.et004CardIIComponent.isReadOnlyCruiser = true;
      this.et004CardIIComponent.isReadOnlyRedigo = true;

      arrCampos.forEach(item => {
        arrSunflix.forEach(flix => {
          if (flix != 'dermacor') {
            this.getFormCard(item + flix).get(item + flix)?.disable();
            this.getFormCard(item + flix).get(item + flix)?.setValue(null);
          }
          else {
            this.getFormCard(item + flix).get(item + flix)?.enable();
          }
        })
      })
      return
    }

    if (verificaTipoTratamentoConvencional && !verificaTipoTratamentoRedigo) {
      this.et004CardIIComponent.isReadOnlyPoncho = true;
      this.et004CardIIComponent.isReadOnlyCruiser = true;
      this.et004CardIIComponent.isReadOnlyRedigo = true;
      this.et004CardIIComponent.isReadOnlyDermacor = true;
      this.et004CardIIComponent.isReadOnlyTSI = true;
      arrCampos.forEach(item => {
        arrSunflix.forEach(flix => {
          if (flix != 'convencional') {
            this.getFormCard(item + flix).get(item + flix)?.disable();
            this.getFormCard(item + flix).get(item + flix)?.setValue(null);
          }
          else {
            this.getFormCard(item + flix).get(item + flix)?.enable();
          }
        })
      })
      return
    }

    if (verificaTipoTratamentoConvencional && verificaTipoTratamentoRedigo) {
      this.et004CardIIComponent.isReadOnlyPoncho = true;
      this.et004CardIIComponent.isReadOnlyCruiser = true;
      this.et004CardIIComponent.isReadOnlyDermacor = true;
      this.et004CardIIComponent.isReadOnlyTSI = true;
      arrCampos.forEach(item => {
        arrSunflix.forEach(flix => {
          if (flix != 'convencional' && flix != 'redigo') {
            this.getFormCard(item + flix).get(item + flix)?.disable();
            this.getFormCard(item + flix).get(item + flix)?.setValue(null);
          }
          else {
            this.getFormCard(item + flix).get(item + flix)?.enable();
          }
        })
      })
      return
    }

    if (verificaTipoTratamentoCruiser && !verificaTipoTratamentoRedigo) {

      this.et004CardIIComponent.isReadOnlyDermacor = true;
      this.et004CardIIComponent.isReadOnlyPoncho = true;
      this.et004CardIIComponent.isReadOnlyRedigo = true;

      arrCampos.forEach(item => {
        arrSunflix.forEach(flix => {
          if (flix != 'cruiser') {
            this.getFormCard(item + flix).get(item + flix)?.disable();
            this.getFormCard(item + flix).get(item + flix)?.setValue(null);
          }
          else {
            this.getFormCard(item + flix).get(item + flix)?.enable();
          }
        })
      })
      if (data != null) {
        pumpStationCruiserInput.setValue(data?.pump_station_calda_poncho);
        correcaoAplicacaoCruiser.setValue(data?.correcao_aplicacao_poncho);
        dosagenCruiser.setValue(data?.poncho_g_por_kg);
        consumoCruiser.setValue(data?.consumo_poncho_ml_por_sc);
      }
      return
    }

    if (verificaTipoTratamentoCruiser && verificaTipoTratamentoRedigo) {

      this.et004CardIIComponent.isReadOnlyDermacor = true;
      this.et004CardIIComponent.isReadOnlyPoncho = true;

      arrCampos.forEach(item => {
        arrSunflix.forEach(flix => {
          if (flix != 'cruiser' && flix != 'redigo') {
            this.getFormCard(item + flix).get(item + flix)?.disable();
            this.getFormCard(item + flix).get(item + flix)?.setValue(null);
          }
          else {
            this.getFormCard(item + flix).get(item + flix)?.enable();
          }
        })
      })

      if (data != null) {
        pumpStationCruiserInput.setValue(data?.pump_station_calda_poncho);
        correcaoAplicacaoCruiser.setValue(data?.correcao_aplicacao_poncho);
        dosagenCruiser.setValue(data?.poncho_g_por_kg);
        consumoCruiser.setValue(data?.consumo_poncho_ml_por_sc);
      }
      return
    }
  }

  public getFormCard(control) {


    if (this.et004CardIIComponent.formulario.contains(control) || this.et004CardIIComponent.formulario.get(control)?.disabled == true) {
      return this.et004CardIIComponent.formulario
    }
    else if (this.et004CardIIIComponent.formulario.contains(control) || this.et004CardIIIComponent.formulario.get(control)?.disabled == true) {
      return this.et004CardIIIComponent.formulario
    }
    else if (this.et004CardVComponent.formulario.contains(control) || this.et004CardVComponent.formulario.get(control)?.disabled == true) {
      return this.et004CardVComponent.formulario
    }
    else {
      return this.et004CardIIComponent.formulario
    }

  }

  private async calcIngredienteAtivoLaudo(): Promise<void> {

    const correcaoAplicacaoPoncho = this.et004CardIIComponent.formulario.get('correcao_aplicacao_poncho')?.value as number;
    const ingredienteAtivoLaudoProdutoPoncho = this.et004CardIIComponent.formulario.get('ingrediente_ativo_laudo_produto_poncho')?.value as number;

    const correcaoAplicacaoCruiser = this.et004CardIIComponent.formulario.get('correcao_aplicacao_cruiser')?.value as number;
    const ingredienteAtivoLaudoProdutoCruiser = this.et004CardIIComponent.formulario.get('ingrediente_ativo_laudo_produto_cruiser')?.value as number;

    const correcaoAplicacaoDermacor = this.et004CardIIComponent.formulario.get('correcao_aplicacao_dermacor')?.value as number;
    const ingredienteAtivoLaudoProdutoDermacor = this.et004CardIIComponent.formulario.get('ingrediente_ativo_laudo_produto_dermacor')?.value as number;

    const correcaoAplicacaoRedigo = this.et004CardIIComponent.formulario.get('correcao_aplicacao_redigo')?.value as number;
    const ingredienteAtivoLaudoProdutoRedigo = this.et004CardIIComponent.formulario.get('ingrediente_ativo_laudo_produto_redigo')?.value as number;

    const calcAtivoPoncho = ingredienteAtivoLaudoProdutoPoncho > 0 ? 1 - (ingredienteAtivoLaudoProdutoPoncho / 600) : 0
    let totalPoncho = 0

    if (calcAtivoPoncho > 0) {
      totalPoncho = calcAtivoPoncho + correcaoAplicacaoPoncho
    } else {
      totalPoncho = 0
    }

    const calcAtivoCruiser = ingredienteAtivoLaudoProdutoCruiser > 0 ? 1 - (ingredienteAtivoLaudoProdutoCruiser / 600) : 0;

    let totalCruiser = 0

    if (calcAtivoCruiser > 0) {
      totalCruiser = calcAtivoCruiser + correcaoAplicacaoCruiser
    } else {
      totalCruiser = 0
    }

    const calcAtivoDermacor = ingredienteAtivoLaudoProdutoDermacor > 0 ? 1 - (ingredienteAtivoLaudoProdutoDermacor / 625) : 0;

    let totalDermacor = 0

    if (calcAtivoDermacor > 0) {
      totalDermacor = calcAtivoDermacor + correcaoAplicacaoDermacor;
    } else {
      totalDermacor = 0
    }

    //DEROSAL:
    const calcAtivoRedigo = ingredienteAtivoLaudoProdutoRedigo > 0 ? 1 - (ingredienteAtivoLaudoProdutoRedigo / 350) : 0;
    let totalRedigo = 0

    if (calcAtivoRedigo > 0) {
      totalRedigo = calcAtivoRedigo + correcaoAplicacaoRedigo;
    } else {
      totalRedigo = 0
    }

    const campoTotal = (totalDermacor + totalRedigo + totalPoncho + totalCruiser);

    this.et004CardIIComponent.formulario.get('correcao_total').setValue(campoTotal.toFixed(2));
  }
  private async calcIngredienteCorrecao() {

    const correcaoLimpezaLinha = this.et004CardIIComponent.formulario.get('correcao_limpeza_linha')?.value as number || 0

    const ingredienteAtivoLaudoPoncho = this.et004CardIIComponent.formulario.get('ingrediente_ativo_laudo_produto_poncho')?.value as number

    const correcaoPerdaProcessoPoncho = this.et004CardIIComponent.formulario.get('correcao_perda_processo_poncho')?.value as number || 0

    const ingredienteAtivoLaudoDermacor = this.et004CardIIComponent.formulario.get('ingrediente_ativo_laudo_produto_dermacor')?.value as number
    const correcaoPerdaProcessoDermacor = this.et004CardIIComponent.formulario.get('correcao_perda_processo_dermacor')?.value as number || 0

    const correcaoPerdaProcessoRedigo = this.et004CardIIComponent.formulario.get('correcao_perda_processo_redigo')?.value as number || 0

    if (ingredienteAtivoLaudoPoncho != null) {
      const correcaoIaPoncho = Number((((600 - ingredienteAtivoLaudoPoncho) / 600) * 100).toFixed(2))
      this.et004CardIIComponent.formulario.get('correcao_ia_poncho').setValue(correcaoIaPoncho)
      if (correcaoPerdaProcessoPoncho != null && correcaoLimpezaLinha != null) {
        const correcaoTotalPoncho = correcaoIaPoncho + correcaoPerdaProcessoPoncho + correcaoLimpezaLinha
        this.et004CardIIComponent.formulario.get('correcao_aplicacao_poncho').setValue(correcaoTotalPoncho)
        if (correcaoTotalPoncho > 5) {

          this.et004CardIIComponent.formulario.get('correcao_aplicacao_poncho')['warning'] = true
        }
        else {
          this.et004CardIIComponent.formulario.get('correcao_aplicacao_poncho')['warning'] = false
        }
      }
    }

    if (ingredienteAtivoLaudoDermacor != null) {
      const correcaoIaDermacor = ((50 - ingredienteAtivoLaudoDermacor) / 50) * 100
      this.et004CardIIComponent.formulario.get('correcao_ia_dermacor').setValue(correcaoIaDermacor)
      if (correcaoPerdaProcessoDermacor != null && correcaoLimpezaLinha != null) {
        const correcaoTotalDermacor = correcaoIaDermacor + correcaoPerdaProcessoDermacor + correcaoLimpezaLinha
        this.et004CardIIComponent.formulario.get('correcao_aplicacao_dermacor').setValue(correcaoTotalDermacor)
        if (correcaoTotalDermacor > 5) {

          this.et004CardIIComponent.formulario.get('correcao_aplicacao_dermacor')['warning'] = true
        }
        else {
          this.et004CardIIComponent.formulario.get('correcao_aplicacao_dermacor')['warning'] = false
        }
      }


    }
    if (correcaoPerdaProcessoRedigo != null && correcaoLimpezaLinha != null) {
      const correcaoTotalRedigo = correcaoPerdaProcessoRedigo + correcaoLimpezaLinha
      this.et004CardIIComponent.formulario.get('correcao_aplicacao_redigo').setValue(correcaoTotalRedigo)
      if (correcaoTotalRedigo > 5) {

        this.et004CardIIComponent.formulario.get('correcao_aplicacao_redigo')['warning'] = true
      }
      else {
        this.et004CardIIComponent.formulario.get('correcao_aplicacao_redigo')['warning'] = false
      }
    }
  }
  //  
  // private async limpaConsumo(consumo){
  //   const correcaoAplicacaoPoncho = !!this.et004CardIIComponent.formulario.get(`correcao_aplicacao_${consumo}`).value ? this.et004CardIIComponent.formulario.get(`correcao_aplicacao_${consumo}`)?.value as number ?? 0 : 0;
  //   if(correcaoAplicacaoPoncho == 0){
  //     this.et004CardIIIComponent.formulario.get(`${consumo}`).setValue(null);
  //   }

  // }

  private async getPoncho(): Promise<void> {

    let resultado: number = 0;
    const tipoTratamento: string = this.et004CardIComponent.formulario.get('tipo_tratamento')?.value as string ?? '';
    var correcaoAplicacaoPoncho = null;
    if (!!tipoTratamento && tipoTratamento?.length > 0 && tipoTratamento?.toUpperCase() !== 'CONVENCIONAL'
      && tipoTratamento?.toUpperCase().trim() !== 'TSI - CRUISER 350' && tipoTratamento?.toUpperCase().trim() !== 'CONVENCIONAL + REDIGO' && tipoTratamento?.toUpperCase().trim() !== 'TSI - CRUISER 600 + REDIGO') {
      const num: number = 0.070;
      const mult: number = 1000;
      const dividendo: number = num * mult;
      let pesoMilSementes = !!this.et004CardIComponent.formulario.get('peso_mil_sementes').value ? this.et004CardIComponent.formulario.get('peso_mil_sementes')?.value as number ?? 0 : 0;
      const divisor: number = (pesoMilSementes * 60);

      correcaoAplicacaoPoncho = !!this.et004CardIIComponent.formulario.get('correcao_aplicacao_poncho').value ? this.et004CardIIComponent.formulario.get('correcao_aplicacao_poncho')?.value as number ?? 0 : 0;
      correcaoAplicacaoPoncho = (1 + (correcaoAplicacaoPoncho / 100));

      if (divisor > 0) {
        resultado = dividendo / divisor;
      }

      resultado = ((resultado * 1.26) * correcaoAplicacaoPoncho);


    }

    else if (tipoTratamento.toUpperCase().trim() === 'TSI - CRUISER 350') {
      const num: number = 0.120;
      const mult: number = 1000;
      const dividendo: number = num * mult;
      let pesoMilSementes = !!this.et004CardIComponent.formulario.get('peso_mil_sementes').value ? this.et004CardIComponent.formulario.get('peso_mil_sementes')?.value as number ?? 0 : 0;
      const divisor: number = (pesoMilSementes * 60);
      correcaoAplicacaoPoncho = !!this.et004CardIIComponent.formulario.get('correcao_aplicacao_prc').value ? this.et004CardIIComponent.formulario.get('correcao_aplicacao_prc')?.value as number ?? 0 : 0;
      correcaoAplicacaoPoncho = (1 + (correcaoAplicacaoPoncho / 100));

      if (divisor > 0) {
        resultado = dividendo / divisor;
      }

      resultado = ((resultado * 1.18) * correcaoAplicacaoPoncho);
    }

    if (tipoTratamento.toUpperCase().trim() === 'TSI - CRUISER 600 + REDIGO') {
      resultado = 0;
      const num: number = 0.070;
      const mult: number = 1000;
      const dividendo: number = num * mult;
      let pesoMilSementes = !!this.et004CardIComponent.formulario.get('peso_mil_sementes').value ? this.et004CardIComponent.formulario.get('peso_mil_sementes')?.value as number ?? 0 : 0;
      const divisor: number = (pesoMilSementes * 60);
      correcaoAplicacaoPoncho = !!this.et004CardIIComponent.formulario.get('correcao_aplicacao_poncho').value ? this.et004CardIIComponent.formulario.get('correcao_aplicacao_poncho')?.value as number ?? 0 : 0;
      correcaoAplicacaoPoncho = (1 + (correcaoAplicacaoPoncho / 100));

      if (divisor > 0) {
        resultado = dividendo / divisor;
      }
      resultado = ((resultado * 1.297) * correcaoAplicacaoPoncho);
    }

    this.et004CardIIIComponent.formulario.get('poncho').setValue(correcaoAplicacaoPoncho ? resultado : null);

    // this.limpaConsumo('poncho');
  }

  private async getCruiser(): Promise<void> {

    let resultado: number = 0;
    const tipoTratamento: string = this.et004CardIComponent.formulario.get('tipo_tratamento')?.value as string ?? '';
    var correcaoAplicacaoCruiser = null;
    if (!!tipoTratamento && tipoTratamento?.length > 0 && tipoTratamento?.toUpperCase() !== 'CONVENCIONAL'
      && tipoTratamento?.toUpperCase().trim() !== 'TSI - CRUISER 350' && tipoTratamento?.toUpperCase().trim() !== 'CONVENCIONAL + REDIGO' && tipoTratamento?.toUpperCase().trim() !== 'TSI - CRUISER 600 + REDIGO') {
      const num: number = 0.070;
      const mult: number = 1000;
      const dividendo: number = num * mult;
      let pesoMilSementes = !!this.et004CardIComponent.formulario.get('peso_mil_sementes').value ? this.et004CardIComponent.formulario.get('peso_mil_sementes')?.value as number ?? 0 : 0;
      const divisor: number = (pesoMilSementes * 60);

      correcaoAplicacaoCruiser = !!this.et004CardIIComponent.formulario.get('correcao_aplicacao_cruiser')?.value ? this.et004CardIIComponent.formulario.get('correcao_aplicacao_cruiser')?.value as number ?? 0 : 0;
      correcaoAplicacaoCruiser = (1 + (correcaoAplicacaoCruiser / 100));

      if (divisor > 0) {
        resultado = dividendo / divisor;
      }

      resultado = ((resultado * 1.26) * correcaoAplicacaoCruiser);
    }

    else if (tipoTratamento.toUpperCase().trim() === 'TSI - CRUISER 350') {
      const num: number = 0.120;
      const mult: number = 1000;
      const dividendo: number = num * mult;
      let pesoMilSementes = !!this.et004CardIComponent.formulario.get('peso_mil_sementes').value ? this.et004CardIComponent.formulario.get('peso_mil_sementes')?.value as number ?? 0 : 0;
      const divisor: number = (pesoMilSementes * 60);
      correcaoAplicacaoCruiser = !!this.et004CardIIComponent.formulario.get('correcao_aplicacao_prc').value ? this.et004CardIIComponent.formulario.get('correcao_aplicacao_prc')?.value as number ?? 0 : 0;
      correcaoAplicacaoCruiser = (1 + (correcaoAplicacaoCruiser / 100));

      if (divisor > 0) {
        resultado = dividendo / divisor;
      }

      resultado = ((resultado * 1.18) * correcaoAplicacaoCruiser);
    }

    if (tipoTratamento.toUpperCase().trim() === 'TSI - CRUISER 600 + REDIGO' || tipoTratamento.toUpperCase().trim() === 'TSI - CRUISER 600') {
      resultado = 0;
      const num: number = 0.070;
      const mult: number = 1000;
      const dividendo: number = num * mult;
      let pesoMilSementes = !!this.et004CardIComponent.formulario.get('peso_mil_sementes').value ? this.et004CardIComponent.formulario.get('peso_mil_sementes')?.value as number ?? 0 : 0;
      const divisor: number = (pesoMilSementes * 60);
      correcaoAplicacaoCruiser = !!this.et004CardIIComponent.formulario.get('correcao_aplicacao_cruiser')?.value ? this.et004CardIIComponent.formulario.get('correcao_aplicacao_cruiser')?.value as number ?? 0 : 0;
      correcaoAplicacaoCruiser = (1 + (correcaoAplicacaoCruiser / 100));

      if (divisor > 0) {
        resultado = dividendo / divisor;
      }
      resultado = ((resultado * 1.297) * correcaoAplicacaoCruiser);
    }

    this.et004CardIIIComponent.formulario.get('cruiser').setValue(correcaoAplicacaoCruiser ? resultado : null);

    // this.limpaConsumo('cruiser');

  }

  private async getRedigo(): Promise<void> {
    let resultado: number = 0;
    const tipoTratamento: string = this.et004CardIComponent.formulario.get('tipo_tratamento')?.value as string ?? '';
    const arrTipoTratamento: string[] = ['TSI - PONCHO + REDIGO', 'TSI - PONCHO + DERMACOR + REDIGO', 'CONVENCIONAL + REDIGO', 'TSI - CRUISER 600 + REDIGO', 'TSI - CRUISER 350 + REDIGO', 'CRUISER 600 + DERMACOR + REDIGO'];
    var correcaoAplicacaoRedigo = null;
    if (!!tipoTratamento && tipoTratamento?.length > 0 && (arrTipoTratamento.includes(tipoTratamento?.trim()?.toUpperCase()))) { //|| tipoTratamento?.toUpperCase().trim() === 'TSI - PONCHO + REDIGO'|| tipoTratamento?.toUpperCase().trim() === 'TSI - PONCHO + DERMARCOR + REDIGO'||tipoTratamento?.toUpperCase().trim() === 'CONVENCIONAL + REDIGO'){
      const num: number = 0.020;
      const mult: number = 1000;
      const dividendo: number = num * mult;
      let pesoMilSementes = !!this.et004CardIComponent.formulario.get('peso_mil_sementes').value ? this.et004CardIComponent.formulario.get('peso_mil_sementes')?.value as number ?? 0 : 0;
      const divisor: number = (pesoMilSementes * 60);
      correcaoAplicacaoRedigo = !!this.et004CardIIComponent.formulario.get('correcao_aplicacao_redigo').value ? this.et004CardIIComponent.formulario.get('correcao_aplicacao_redigo')?.value as number ?? 0 : 0;
      correcaoAplicacaoRedigo = (1 + (correcaoAplicacaoRedigo / 100));

      if (divisor > 0) {
        resultado = dividendo / divisor;
      }

      resultado = ((resultado * 1.12) * correcaoAplicacaoRedigo);
    }
    this.et004CardIIIComponent.formulario.get('redigo').setValue(correcaoAplicacaoRedigo ? resultado : null);

    // this.limpaConsumo('redigo');
  }

  private async getDermacor(): Promise<void> {
    let resultado: number = 0;
    const tipoTratamento: string = this.et004CardIComponent.formulario.get('tipo_tratamento')?.value as string ?? '';
    const arrTipoTratamento: string[] = [
      'TSI - PONCHO + DERMACOR',
      'TSI - PONCHO + DERMACOR + DEROSAL',
      'TSI - PONCHO + DERMACOR + REDIGO',
      'TSI - DERMACOR',
      'CRUISER 600 +  DERMACOR',
      'CRUISER 600 + DERMACOR + REDIGO',
    ];
    var correcaoAplicacaoDermacor = null;
    if (!!tipoTratamento && tipoTratamento?.length > 0 && (arrTipoTratamento.includes(tipoTratamento?.trim()?.toUpperCase()))) {
      const num: number = 0.048;
      const mult: number = 1000;
      const dividendo: number = num * mult;

      let pesoMilSementes = !!this.et004CardIComponent.formulario.get('peso_mil_sementes').value ? this.et004CardIComponent.formulario.get('peso_mil_sementes')?.value as number ?? 0 : 0;
      const divisor: number = (pesoMilSementes * 60);

      correcaoAplicacaoDermacor = !!this.et004CardIIComponent.formulario.get('correcao_aplicacao_dermacor').value ? this.et004CardIIComponent.formulario.get('correcao_aplicacao_dermacor')?.value as number ?? 0 : 0;
      correcaoAplicacaoDermacor = (1 + (correcaoAplicacaoDermacor / 100));

      if (divisor > 0) {
        resultado = dividendo / divisor;
      }

      resultado = ((resultado * 1.2617) * correcaoAplicacaoDermacor);
    }
    this.et004CardIIIComponent.formulario.get('dermacor').setValue(correcaoAplicacaoDermacor ? resultado : null);
    // this.limpaConsumo('dermacor');
  }

  private async getConsumoPoncho(): Promise<void> {

    let resultado: number = 0;
    let divisor: number = 1;
    let pumpStaPoncho: number = this.et004CardIIComponent.formulario.get('pump_station_poncho')?.value as number ?? 0;
    const pesoTotalLoteTratado: number = this.et004CardIVComponent.formulario.get('peso_total_lote_tratado')?.value as number ?? 0;
    const pesoLiquidoRegulagemCbt: number = this.et004CardIComponent.formulario.get('peso_liquido_regulagem_cbt')?.value as number ?? 0;
    const tipoTratamento: string = this.et004CardIComponent.formulario.get('tipo_tratamento')?.value as string ?? '';

    if (!!tipoTratamento && tipoTratamento?.length > 0 && tipoTratamento?.toUpperCase() !== 'CONVENCIONAL' && tipoTratamento?.toUpperCase().trim() !== 'TSI - CRUISER 350' && tipoTratamento?.toUpperCase().trim() !== 'TSI - CRUISER 600 + REDIGO' || tipoTratamento?.toUpperCase().trim() === 'TSI - PONCHO + DERMACOR + REDIGO' || tipoTratamento?.toUpperCase().trim() === 'TSI - PONCHO + DERMACOR' || tipoTratamento?.toUpperCase().trim() === 'TSI - PONCHO + REDIGO') {
      const num: number = 1.26;
      pumpStaPoncho = pumpStaPoncho / num;

      if (pesoLiquidoRegulagemCbt > 0) {
        divisor = pesoTotalLoteTratado / pesoLiquidoRegulagemCbt;
      } else {
        divisor = pesoTotalLoteTratado / divisor;
      }

      if (divisor > 0) {
        resultado = pumpStaPoncho / divisor;
      }
    } else if (tipoTratamento.toUpperCase().trim() === 'TSI - CRUISER 350') {

      const num: number = 1.18;

      pumpStaPoncho = pumpStaPoncho / num;



      if (pesoLiquidoRegulagemCbt > 0) {

        divisor = pesoTotalLoteTratado / pesoLiquidoRegulagemCbt;

      } else {

        divisor = pesoTotalLoteTratado / divisor;

      }

      if (divisor > 0) {

        resultado = pumpStaPoncho / divisor;

      }

    }
    if (tipoTratamento.toUpperCase().trim() === 'TSI - CRUISER 600 + REDIGO') {


      let PumpStationPonchoCruiser = this.et004CardIIComponent.formulario.get('pump_station_poncho')?.value as number ?? 0;
      let pesoTotalLoteTratado = this.et004CardIVComponent.formulario.get('peso_total_lote_tratado')?.value as number ?? 0;
      let pesoLiquidoRegulagemCbt = this.et004CardIComponent.formulario.get('peso_liquido_regulagem_cbt')?.value as number ?? 0;
      resultado = 0;

      resultado = (PumpStationPonchoCruiser / 1.297) / (pesoTotalLoteTratado / pesoLiquidoRegulagemCbt);

    }



    this.et004CardVComponent.formulario.get('consumo_poncho').setValue(resultado);
  }

  private async getConsumoCruiser(): Promise<void> {

    let resultado: number = 0;
    let divisor: number = 1;
    let pumpStaCruiser: number = this.et004CardIIComponent.formulario.get('pump_station_cruiser')?.value as number ?? 0;
    const pesoTotalLoteTratado: number = this.et004CardIVComponent.formulario.get('peso_total_lote_tratado')?.value as number ?? 0;
    const pesoLiquidoRegulagemCbt: number = this.et004CardIComponent.formulario.get('peso_liquido_regulagem_cbt')?.value as number ?? 0;
    const tipoTratamento: string = this.et004CardIComponent.formulario.get('tipo_tratamento')?.value as string ?? '';

    if (!!tipoTratamento && tipoTratamento?.length > 0 &&
      tipoTratamento?.toUpperCase() !== 'CONVENCIONAL' &&
      tipoTratamento?.toUpperCase().trim() !== 'TSI - CRUISER 350' &&
      tipoTratamento?.toUpperCase().trim() !== 'TSI - CRUISER 600 + REDIGO' ||
      tipoTratamento?.toUpperCase().trim() === 'TSI - PONCHO + DERMACOR + REDIGO' ||
      tipoTratamento?.toUpperCase().trim() === 'TSI - PONCHO + DERMACOR' ||
      tipoTratamento?.toUpperCase().trim() === 'TSI - PONCHO + REDIGO') {
      const num: number = 1.26;
      pumpStaCruiser = pumpStaCruiser / num;

      if (pesoLiquidoRegulagemCbt > 0) {
        divisor = pesoTotalLoteTratado / pesoLiquidoRegulagemCbt;
      } else {
        divisor = pesoTotalLoteTratado / divisor;
      }

      if (divisor > 0) {
        resultado = pumpStaCruiser / divisor;
      }
    } else if (tipoTratamento.toUpperCase().trim() === 'TSI - CRUISER 350') {

      const num: number = 1.18;

      pumpStaCruiser = pumpStaCruiser / num;



      if (pesoLiquidoRegulagemCbt > 0) {

        divisor = pesoTotalLoteTratado / pesoLiquidoRegulagemCbt;

      } else {

        divisor = pesoTotalLoteTratado / divisor;

      }

      if (divisor > 0) {

        resultado = pumpStaCruiser / divisor;

      }

    }
    if (tipoTratamento.toUpperCase().trim() === 'TSI - CRUISER 600 + REDIGO') {


      let PumpStationCruiser = this.et004CardIIComponent.formulario.get('pump_station_cruiser')?.value as number ?? 0;
      let pesoTotalLoteTratado = this.et004CardIVComponent.formulario.get('peso_total_lote_tratado')?.value as number ?? 0;
      let pesoLiquidoRegulagemCbt = this.et004CardIComponent.formulario.get('peso_liquido_regulagem_cbt')?.value as number ?? 0;
      resultado = 0;

      resultado = (PumpStationCruiser / 1.297) / (pesoTotalLoteTratado / pesoLiquidoRegulagemCbt);

    }



    this.et004CardVComponent.formulario.get('consumo_cruiser').setValue(resultado);
  }

  private async getConsumoRedigo() {

    let resultado: number = 0;
    let divisor: number = 1;
    let pumpStaRedigo: number = this.et004CardIIComponent.formulario.get('pump_station_redigo')?.value as number ?? 0;
    const pesoTotalLoteTratado: number = this.et004CardIVComponent.formulario.get('peso_total_lote_tratado')?.value as number ?? 0;
    const pesoLiquidoRegulagemCbt: number = this.et004CardIComponent.formulario.get('peso_liquido_regulagem_cbt')?.value as number ?? 0;
    const tipoTratamento: string = this.et004CardIComponent.formulario.get('tipo_tratamento')?.value as string ?? '';


    if (!!tipoTratamento && tipoTratamento?.length > 0 ||
      tipoTratamento?.toUpperCase() === 'TSI - PONCHO + REDIGO' ||
      tipoTratamento?.toUpperCase() === 'TSI - PONCHO + DERMACOR + REDIGO' ||
      tipoTratamento?.toUpperCase() === 'CONVENCIONAL + REDIGO' ||
      tipoTratamento?.toUpperCase() === 'TSI - CRUISER 350 + REDIGO' ||
      tipoTratamento?.toUpperCase() === 'CRUISER 600 + DERMACOR + REDIGO') {

      const num: number = 1.12;
      pumpStaRedigo = pumpStaRedigo / num;

      if (pesoLiquidoRegulagemCbt > 0) {
        divisor = pesoTotalLoteTratado / pesoLiquidoRegulagemCbt;
      } else {
        divisor = pesoTotalLoteTratado / divisor;
      }

      if (divisor > 0) {
        resultado = pumpStaRedigo / divisor;
      }
    }

    this.et004CardVComponent.formulario.get('consumo_redigo').setValue(resultado);
  }

  private async getConsumoDermacor(): Promise<void> {

    let resultado: number = 0;
    let divisor: number = 1;
    let pumpStaDermacor: number = this.et004CardIIComponent.formulario.get('pump_station_dermacor')?.value as number ?? 0;
    const pesoTotalLoteTratado: number = this.et004CardIVComponent.formulario.get('peso_total_lote_tratado')?.value as number ?? 0;
    const pesoLiquidoRegulagemCbt: number = this.et004CardIComponent.formulario.get('peso_liquido_regulagem_cbt')?.value as number ?? 0;
    const tipoTratamento: string = this.et004CardIComponent.formulario.get('tipo_tratamento')?.value as string ?? '';
    const arrTipoTratamento: string[] = [
      'TSI - PONCHO + DERMACOR',
      'TSI - PONCHO + DERMACOR + DEROSAL',
      'TSI - PONCHO + DERMACOR + REDIGO',
      'TSI - DERMACOR',
      'CRUISER 600 +  DERMACOR',
      'CRUISER 600 + DERMACOR + REDIGO',
    ];

    if (!!tipoTratamento && tipoTratamento?.length > 0 && (arrTipoTratamento.includes(tipoTratamento?.trim()?.toUpperCase()))) {
      const num: number = 1.2617;
      pumpStaDermacor = pumpStaDermacor / num;

      if (pesoLiquidoRegulagemCbt > 0) {
        divisor = pesoTotalLoteTratado / pesoLiquidoRegulagemCbt;
      } else {
        divisor = pesoTotalLoteTratado / divisor;
      }

      if (divisor > 0) {
        resultado = pumpStaDermacor / divisor;
      }
    }

    this.et004CardVComponent.formulario.get('consumo_dermacor').setValue(resultado);
  }

  private async getTalkumGloss(): Promise<void> {
    let resultado: number = 0;
    const pesoTotalLoteTratado: number = this.et004CardIVComponent.formulario.get('peso_total_lote_tratado')?.value as number ?? 0;
    const talkumGloss = !!this.et004CardIIComponent.formulario.get('talkum_gloss').value ? this.et004CardIIComponent.formulario.get('talkum_gloss')?.value as number ?? 0 : 0;
    if (pesoTotalLoteTratado > 0) {
      resultado = talkumGloss / pesoTotalLoteTratado;
    }
    this.et004CardVComponent.formulario.get('consumo_talkum_gloss').setValue(resultado);
  }

  private async checkPolimeroField(): Promise<void> {
    const tipoTratamento: string = !!this.et004CardIComponent.formulario.get('tipo_tratamento')?.value ? this.et004CardIComponent.formulario.get('tipo_tratamento')?.value : null;
    // const arrTipoTratamento: string[] = ['TSI - PONCHO', 'TSI - PONCHO + DERMACOR', 'TSI - PONCHO + DEROSAL', 'TSI - PONCHO + DERMACOR + DEROSAL'];
    if (!!tipoTratamento && tipoTratamento?.length > 0 && (tipoTratamento.toUpperCase().includes('TSI'))) {
      this.et004CardIIIComponent.isReadOnlyPolimero = false;
    } else {
      this.et004CardIIIComponent.isReadOnlyPolimero = true;
      this.et004CardIIIComponent.formulario.get('polimero_list').setValue(null);
      this.et004CardIIIComponent.formulario.get('calda_tsi').setValue(null);
      this.et004CardIIIComponent.formulario.get('polimero').setValue(null);
      this.et004CardIIIComponent.formulario.get('polimero').setErrors(null);

    }
  }

  private async checkAguaField(): Promise<void> {
    const tipoTratamento: string = !!this.et004CardIComponent.formulario.get('tipo_tratamento')?.value ? this.et004CardIComponent.formulario.get('tipo_tratamento')?.value : null;
    // const arrTipoTratamento: string[] = ['TSI - PONCHO', 'TSI - PONCHO + DERMACOR', 'TSI - PONCHO + DEROSAL', 'TSI - PONCHO + DERMACOR + DEROSAL'];

    if (!!tipoTratamento && tipoTratamento?.length > 0 && (tipoTratamento.toUpperCase().includes('TSI'))) {
      this.et004CardIIIComponent.isReadOnlyAgua = false;
    } else {
      this.et004CardIIIComponent.isReadOnlyAgua = true;
      this.et004CardIIIComponent.formulario.get('agua').setValue(null);
    }
  }

  private async checkCaldaConvencionalField(): Promise<void> {
    const tipoTratamento: string = !!this.et004CardIComponent.formulario.get('tipo_tratamento')?.value ? this.et004CardIComponent.formulario.get('tipo_tratamento')?.value : null;
    // const arrTipoTratamento: string[] = ['CONVENCIONAL'];

    if (!!tipoTratamento && tipoTratamento?.length > 0 && (tipoTratamento.toUpperCase().includes('TSI'))) {
      this.et004CardIIIComponent.isReadOnlyCaldaConvencional = true;
      this.et004CardIIComponent.isReadOnlyCaldaConvencional = true;
      this.et004CardIIIComponent.formulario.get('calda_convencional').setValue(null);
      this.et004CardIIComponent.formulario.get('pump_station_calda_convencional').setValue(null);
    } else {
      this.et004CardIIIComponent.isReadOnlyCaldaConvencional = false;
      this.et004CardIIComponent.isReadOnlyCaldaConvencional = false;
    }
  }

  private async ValidateTratamentoDate() {

    const inicioTratamentoData: string = this.et004CardIVComponent.formulario.get('inicio_tratamento_data')?.value;
    const terminoTratamentoData: string = this.et004CardIVComponent.formulario.get('termino_tratamento_data')?.value;

    const rangeDateTratamento: boolean = this.generalService.isValidRangeDate(inicioTratamentoData, terminoTratamentoData);

    if (rangeDateTratamento === true) {

      this.notificationService.sendNotification('', TypeMessage.InvalidRangeDate, ActionMessage.Error);
      // this.et004CardIVComponent.formulario.get('inicio_tratamento_data')?.setErrors({ inicio_tratamento_data: true });
      this.et004CardIVComponent.formulario.get('termino_tratamento_data')?.setErrors({ termino_tratamento_data: true });
    }
  }

  private async ValidateHour() {

    const inicioTratamentoHora: string = this.et004CardIVComponent.formulario.get('inicio_tratamento_hora')?.value;
    const terminoTratamentoHora: string = this.et004CardIVComponent.formulario.get('termino_tratamento_hora')?.value;
    const inicioTratamentoData: string = this.et004CardIVComponent.formulario.get('inicio_tratamento_data')?.value;
    const terminoTratamentoData: string = this.et004CardIVComponent.formulario.get('termino_tratamento_data')?.value;
    const rangeHourTratamento: boolean = this.generalService.isValidRangeHour(inicioTratamentoHora, terminoTratamentoHora, inicioTratamentoData, terminoTratamentoData);
    if (rangeHourTratamento === true) {

      this.notificationService.sendNotification('', TypeMessage.InvalideRangeHour, ActionMessage.Error);
      this.et004CardIVComponent.formulario.get('termino_tratamento_hora')?.setErrors({ termino_tratamento_hora: true });
    }
  }

  private async checkLotePosLimpeza() {
    const lotePosLimpeza = this.et004CardIComponent.formulario.get('lote_pos_limpeza_de_linha')?.value as string
    if (lotePosLimpeza?.toLowerCase() == 'sim') {
      this.et004CardIIComponent.isReadOnlyLotePos = false

    }
    else {
      this.et004CardIIComponent.isReadOnlyLotePos = true
      this.et004CardIIComponent.formulario.get('correcao_limpeza_linha').setValue(null);
    }
  }
  private async getCalcCaldaTsi() {
    const polimero = this.et004CardIIIComponent.formulario.get('polimero_list')?.value as string;

    const agua = this.et004CardIIIComponent.formulario.get('agua')?.value as number;
    const polimeroKg = this.et004CardIIIComponent.formulario.get('polimero')?.value as number;
    let calcCalda = null;

    if (polimero?.toLowerCase().includes('disco') && !polimero?.toLowerCase().includes('l322') && agua && polimeroKg) {
        calcCalda = (1.0 * 1.094 + 0.08 * 0.94 + 0.016 * 1.02 + polimeroKg * 1.19 + agua * 1);
    }

    if (polimero?.toLowerCase().includes('peridiam') || polimero?.toLowerCase().includes('l322')) {
        if (polimeroKg && agua) {
            calcCalda = (1.0 * 1.094 + 0.08 * 0.94 + 0.016 * 1.02 + polimeroKg * 1.10 + agua * 1);
        }
    }

    this.et004CardIIIComponent.formulario.get('calda_tsi').setValue(calcCalda);
}
  // private async getConsumoDerosalSul(): Promise<void> {
  //    let resultado: number = 0;
  //    let divisor: number = 1;
  //    let pumpStaDerosalSul: number = this.et004CardIIComponent.formulario.get('pump_station_derosal_plus')?.value as number ?? 0;
  //    const pesoTotalLoteTratado: number = this.et004CardIVComponent.formulario.get('peso_total_lote_tratado')?.value as number ?? 0;
  //    const pesoLiquidoRegulagemCbt: number = this.et004CardIComponent.formulario.get('peso_liquido_regulagem_cbt')?.value as number ?? 0;
  //   const tipoTratamento: string = this.et004CardIComponent.formulario.get('tipo_tratamento')?.value as string ?? '';
  //   const arrTipoTratamento: string[] = ['TSI - PONCHO + DEROSAL', 'TSI - PONCHO + DERMACOR + DEROSAL'];

  //   if (!!tipoTratamento && tipoTratamento?.length > 0 && (arrTipoTratamento.includes(tipoTratamento?.trim()?.toUpperCase()))) {
  //      const num: number = 1.20020;
  //     pumpStaDerosalSul = pumpStaDerosalSul / num;

  //    if (pesoLiquidoRegulagemCbt > 0) {
  //      divisor = pesoTotalLoteTratado / pesoLiquidoRegulagemCbt;
  //   } else {
  //    divisor = pesoTotalLoteTratado / divisor;
  //    }

  //   if (divisor > 0) {
  //      resultado = pumpStaDerosalSul / divisor;
  //  }
  //  }

  //  this.et004CardVComponent.formulario.get('consumo_derosal').setValue(resultado);
  // }

  //private async getDerosalPlus(): Promise<void> {
  //  let resultado: number = 0;
  //  const tipoTratamento: string = this.et004CardIComponent.formulario.get('tipo_tratamento')?.value as string ?? '';
  //  const arrTipoTratamento: string[] = ['TSI - PONCHO + DEROSAL', 'TSI - PONCHO + DERMACOR + DEROSAL'];

  ///  if (!!tipoTratamento && tipoTratamento?.length > 0 && (arrTipoTratamento.includes(tipoTratamento?.trim()?.toUpperCase()))) {

  //   const num: number = 0.040;
  //   const mult: number = 1000;
  //   const dividendo: number = num * mult;

  //  let pesoMilSementes = !!this.et004CardIComponent.formulario.get('peso_mil_sementes').value ? this.et004CardIComponent.formulario.get('peso_mil_sementes')?.value as number ?? 0 : 0;
  // const divisor: number = (pesoMilSementes * 60);

  //  let correcaoAplicacaoPrc = !!this.et004CardIIComponent.formulario.get('correcao_aplicacao_prc').value ? this.et004CardIIComponent.formulario.get('correcao_aplicacao_prc')?.value as number ?? 0 : 0;
  //  correcaoAplicacaoPrc = (1 + (correcaoAplicacaoPrc / 100));

  //  if (divisor > 0) {
  //     resultado = dividendo / divisor;
  // }

  // resultado = ((resultado * 1.20020) * correcaoAplicacaoPrc);
  //  }

  // this.et004CardIIIComponent.formulario.get('derosal_plus').setValue(resultado);
  //  }


  // FIM DO CODIGO DE CALCULO
}



